import nBossConnection from 'modules/base/service/nBossConnection';

class AsszociaciosLeirasService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'asszociaciosLeirasControl';
	}

	/**
	 * @param {assocId} assocId
	 * @return {Promise<String>}
	 */
	showQuestion(assocId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/showQuestion`, { assocId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new AsszociaciosLeirasService();
